import { render, staticRenderFns } from "./miniCard.vue?vue&type=template&id=73f4fdee&scoped=true"
import script from "./miniCard.vue?vue&type=script&lang=js"
export * from "./miniCard.vue?vue&type=script&lang=js"
import style0 from "./miniCard.vue?vue&type=style&index=0&id=73f4fdee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4fdee",
  null
  
)

export default component.exports